import styled from "styled-components";

export const CloseButtonContainer = styled.div`
  width: 16px;
  height: 16px;
  // Width of the modal is 500, minus the 16px width of this div
  margin-left: 484px;
  margin-bottom: 12px;

  svg {
    cursor: pointer;
  }
`;

export const MainContainer = styled.div`
  background-color: #ffffff;
  border: 1px solid #ebeafb;
  border-radius: 2px;
  box-sizing: border-box;
  padding: 28px 36px;
`;

export const Header = styled.div`
  color: #212530;
  font-family: "MaisonNeue", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.75px;
  line-height: 32px;
  text-align: left;
  margin-bottom: 20px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

export const Label = styled.div`
  color: #2a2a3d;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: -0.2px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
`;

export const Error = styled.div`
  color: #f94d63;
`;

export const Input = styled.input`
  background-color: #ffffff;
  border: 1px solid #ebeafb;
  border-radius: 2px;
  box-sizing: border-box;
  height: 50px;
  color: #2a2a3d;
  font-size: 14px;
  font-weight: 500;
  padding-left: 20px;

  &:focus {
    border: 1px solid #5d69e6;
    color: #2a2a3d;
    outline: none;
  }

  &::-webkit-input-placeholder {
    color: #9b9bc2;
    font-weight: 400;
  }

  &::-moz-placeholder {
    color: #9b9bc2;
    font-weight: 400;
  }

  &:-ms-input-placeholder {
    color: #9b9bc2;
    font-weight: 400;
  }

  &:-moz-placeholder {
    color: #9b9bc2;
    font-weight: 400;
  }
  pointer-events: ${p => (p.disabled ? "none" : "auto")};
  opacity: ${p => (p.disabled ? 0.5 : 1)};
`;

export const SubmitButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const SubmitButton = styled.button`
  background-color: #5d69e6;
  opacity: ${props => (props.disabled ? "0.4" : "1")};
  border-radius: 25px;
  border-style: solid;
  padding: 2px 7px;
  width: 160px;
  height: 50px;
  margin-top: 24px;
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};

  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.27px;
  line-height: 19px;

  &:focus {
    outline: none;
  }
`;

export const ContentContainer = styled(MainContainer)`
  min-height: 374px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  svg {
    margin-top: 24px;
    margin-bottom: 12px;
  }
`;

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 72px;
`;

export const Description = styled.div`
  color: #2a2a3d;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.5px;

  span {
    font-weight: 500;
  }
`;

export const GotItButtonContainer = styled(SubmitButtonContainer)`
  justify-content: center;
`;
